import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function FrontPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="front-page" className="page">
      {loading ? (
        <div className="loader loader_bubble"></div>
      ) : (
        <>
          <div>
            <img id="logo" src={require('../img/logo.png')} alt="logo" />
          </div>
          <button className="frontbtn" onClick={() => navigate('/sign-in')}>Sign In</button>
          <button className="frontbtn" onClick={() => navigate('/sign-up')}>Sign Up</button>
        </>
      )}
    </div>
  );
}

export default FrontPage;
